import NiceModal from '@ebay/nice-modal-react';
import { forEachObjIndexed } from 'ramda';

import { setValue } from '@gef-ui/form-core/stream/transfer/control';

import MODALS from 'constants/modals';
import fetch from 'features/common/fetch';
import { setManagerLogin } from 'features/views/settings/marketPlaceAgencies/slice';

import { searchUserTypes } from './constants';
import { saveSubordinates, saveSuperiors, setUserDataDBFlag } from './slice';

export const searchUser =
	(formName, type = searchUserTypes.USER_LIST_SEARCH) =>
	async (dispatch, getState, { getFormData, sendControlNext }) => {
		const formData = await getFormData(formName);
		const correctFormData = {
			login: formData?.login,
			sellerIn: formData?.sellerIn,
			firstName: formData?.userFirstName,
			surname: formData?.userSurname,
		};

		NiceModal.show(MODALS.user_search, {
			type,
			formData: correctFormData,
			onSelect: (user) => {
				// userLogin is returned in MarketPlaceAgenciesSettings userSearch, unlike in taskCreatingPages, taskForwarding (returns login)
				const { login, userLogin, sellerIn, firstName, surname, managerLogin } = user;

				const fieldsToUpdateResolverSettings = {
					login: login || userLogin,
					sellerIn,
					userFirstName: firstName,
					userSurname: surname,
				};

				forEachObjIndexed((value, key) => {
					sendControlNext(formName, setValue({ fieldName: key, value }));
				}, fieldsToUpdateResolverSettings);

				dispatch(setUserDataDBFlag(true));
				if (type === searchUserTypes.MARKET_PLACE_AGENCIES_SEARCH) {
					dispatch(setManagerLogin(managerLogin));
				}
			},
		});
	};

export const fetchUsers = (taskType) => (dispatch) => {
	dispatch(
		fetch.actions.get(fetch.constants.urls.userList, {
			queryParams: {
				userHierarchy: taskType,
				sort: ['surname,asc', 'firstName,asc'],
				size: 1000,
			},
			onSuccess: [
				(response) => () => {
					if (taskType === 'superior') {
						dispatch(saveSuperiors(response?.body?.data));
					} else {
						dispatch(saveSubordinates(response?.body?.data));
					}
				},
			],
		}),
	);
};
